import angular from 'angular';
import uiRouter from 'angular-ui-router';
import mainComponent from './main.component';

let mainModule = angular.module('main', [
  uiRouter
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider
    .state('main', {
        component: 'main',
        redirectTo: 'home',
        resolve: {
            user: (LoginService) => {
                return LoginService.getCurrent().then(user => {
                    return user;
                }, err => {
                    return null;
                });
            }
        }
    });
})

.component('main', mainComponent)
  
.name;

export default mainModule;
